import { WEDDING_CAKES } from "../WeddingCakes/weddingCakeData";

const Cakes = Object.freeze({
    RAFAELLO: "rafaello",
    CROWN: "crown",
    CUSTOMIZED_BDAY_CAKE: "customized_bday_cake",
    HONEY_CAKE: "honey_cake",
    NAPOLEON_PLAIN: "napoleon_plain",
    SAMAR_CAKE: "samar_cake",
    BDAY_FRUIT_CAKE: "bday_fruit_cake",
    NUMBERS_BDAY_CAKE: "numbers_bday_cake",
    NAPOLEON_WITH_BERRIES: "napoleon_with_berries",
    BLACK_CAKE: "black_cake",
    BABY_SHOWER_CAKE: "baby_shower",
    CINNAMOROLL_CAKE: "cinnamoroll",
    GRADUATION_CAKE: "graduation",
    GRADUATION_CAKE_2: "graduation_2",
    WEDDING_CAKE: "wedding",
    BIRTHDAY_QUEEN: "birthday_queen",
    PIKACHU_CAKE: "pikachu",
    KUROMI_CAKE: "kuromi",
    PEPPA_PIG_CAKE: "peppa_pig",
    WAFFLE_ROSE_CAKE: "waffle_rose",
});

const DEFAULT_SIZE_OPTIONS = Object.freeze([
  { id: '6-4', label: '6" with [ 6-8 people ] - $85' },
  { id: '8-4', label: '8" with [ 10-12 people ] - $105' },
  { id: '10-4', label: '10" with [ 14-16 people ] - $140' },
]);

const DEFAULT_FLAVOUR_OPTIONS = Object.freeze([
  { id: 'vanilla', label: 'Vanilla' },
  { id: 'vanilla_raspberry', label: 'Vanilla Raspberry' },
  { id: 'chocolate', label: 'Chocolate' },
  { id: 'chocolate_cherry', label: 'Chocolate Cherry' },
  { id: 'chocolate_raspberry', label: 'Chocolate Raspberry' }
]);

const HONEY_CAKE_SIZE_OPTIONS = Object.freeze([
  { id: '6-4', label: '6" with [ 6-8 people ] - $75' },
  { id: '8-4', label: '8" with [ 10-12 people ] - $95' },
  { id: '10-4', label: '10" with [ 14-16 people ] - $125' },
]);

const HONEY_CAKE_FLAVOUR_OPTIONS = Object.freeze([
  { id: 'vanilla', label: 'Vanilla' },
  { id: 'vanilla_raspberry', label: 'Vanilla Raspberry' },
  { id: 'chocolate', label: 'Chocolate' },
  { id: 'chocolate_raspberry', label: 'Chocolate Raspberry' }
]);

const NAPALEON_SIZE_OPTIONS = Object.freeze([
  { id: '6-4', label: '6" with [ 6-8 people ] - $70' },
  { id: '8-4', label: '8" with [ 10-12 people ] - $90' },
  { id: '10-4', label: '10" with [ 14-16 people ] - $120' },
]);

const NAPALEON_WITH_BERRIES_SIZE_OPTIONS = Object.freeze([
  { id: '6-4', label: '6" with [ 6-8 people ] - $95' },
  { id: '8-4', label: '8" with [ 10-12 people ] - $115' },
  { id: '10-4', label: '10" with [ 14-16 people ] - $140' },
]);

const NAPALEON_FLAVOUR_OPTIONS = Object.freeze([
  { id: 'vanilla', label: 'Vanilla' }
]);

const CUSTOM_SIZE_OPTIONS = Object.freeze([
  { id: 'custom-1', label: 'Contact us' },
]);

const PEPPA_PIG_SIZE_OPTIONS = Object.freeze([
  { id: '22-16', label: '8" and 6" [ 20-25 people ] - $300' },
]);

const PIKACHU_SIZE_OPTIONS = Object.freeze([
  { id: '10-4', label: '10" with [ 14-16 people ] - $120' },
  { id: '12-4', label: '12" with [ 18-20 people ] - $150' },
  { id: '14-4', label: '14" with [ 22-24 people ] - $180' },
]);

const KUROMI_SIZE_OPTIONS = Object.freeze([
  { id: '6-4', label: '6" with [ 6-8 people ] - $90' },
  { id: '8-4', label: '8" with [ 10-12 people ] - $115' },
  { id: '10-4', label: '10" with [ 14-16 people ] - $140' },
]);

const WAFFLE_ROSE_SIZE_OPTIONS = Object.freeze([
  { id: '6-inch', label: '6" [ 8-10 people ] - $120' },
]);

const WEDDING_SIZE_OPTIONS = Object.freeze([
  { id: '3-layer-50', label: '3-layer serves 50 people' },
]);

// Wedding cakes use their own size description and the default flavours.
const weddingOptions = (options) =>
  Object.fromEntries(WEDDING_CAKES.map(({ id }) => [id, options]));

const weddingSizeOptions = () =>
  Object.fromEntries(WEDDING_CAKES.map(({ id, size }) => [
    id,
    size ? Object.freeze([{ id: 'custom-size', label: size }]) : WEDDING_SIZE_OPTIONS,
  ]));

// Map cake IDs to their size options. For now, all use default options.
const CakeSizeOptions = Object.freeze({
  DEFAULT: DEFAULT_SIZE_OPTIONS,
  [Cakes.RAFAELLO]: DEFAULT_SIZE_OPTIONS,
  [Cakes.CROWN]: DEFAULT_SIZE_OPTIONS,
  [Cakes.CUSTOMIZED_BDAY_CAKE]: CUSTOM_SIZE_OPTIONS,
  [Cakes.HONEY_CAKE]: HONEY_CAKE_SIZE_OPTIONS,
  [Cakes.NAPOLEON_PLAIN]: NAPALEON_SIZE_OPTIONS,
  [Cakes.SAMAR_CAKE]: DEFAULT_SIZE_OPTIONS,
  [Cakes.BDAY_FRUIT_CAKE]: DEFAULT_SIZE_OPTIONS,
  [Cakes.NUMBERS_BDAY_CAKE]: DEFAULT_SIZE_OPTIONS,
  [Cakes.NAPOLEON_WITH_BERRIES]: NAPALEON_WITH_BERRIES_SIZE_OPTIONS,
  [Cakes.BLACK_CAKE]: DEFAULT_SIZE_OPTIONS,
  [Cakes.BABY_SHOWER_CAKE]: DEFAULT_SIZE_OPTIONS,
  [Cakes.CINNAMOROLL_CAKE]: DEFAULT_SIZE_OPTIONS,
  [Cakes.GRADUATION_CAKE]: DEFAULT_SIZE_OPTIONS,
  [Cakes.GRADUATION_CAKE_2]: DEFAULT_SIZE_OPTIONS,
  [Cakes.WEDDING_CAKE]: CUSTOM_SIZE_OPTIONS,
  [Cakes.BIRTHDAY_QUEEN]: DEFAULT_SIZE_OPTIONS,
  [Cakes.PIKACHU_CAKE]: PIKACHU_SIZE_OPTIONS,
  [Cakes.KUROMI_CAKE]: KUROMI_SIZE_OPTIONS,
  [Cakes.PEPPA_PIG_CAKE]: PEPPA_PIG_SIZE_OPTIONS,
  [Cakes.WAFFLE_ROSE_CAKE]: WAFFLE_ROSE_SIZE_OPTIONS,
  ...weddingSizeOptions(),
});

// Map cake IDs to their flavour options. For now, all use default options.
const CakeFlavourOptions = Object.freeze({
  DEFAULT: DEFAULT_FLAVOUR_OPTIONS,
  [Cakes.RAFAELLO]: DEFAULT_FLAVOUR_OPTIONS,
  [Cakes.CROWN]: DEFAULT_FLAVOUR_OPTIONS,
  [Cakes.CUSTOMIZED_BDAY_CAKE]: DEFAULT_FLAVOUR_OPTIONS,
  [Cakes.HONEY_CAKE]: HONEY_CAKE_FLAVOUR_OPTIONS,
  [Cakes.NAPOLEON_PLAIN]: NAPALEON_FLAVOUR_OPTIONS,
  [Cakes.SAMAR_CAKE]: DEFAULT_FLAVOUR_OPTIONS,
  [Cakes.BDAY_FRUIT_CAKE]: DEFAULT_FLAVOUR_OPTIONS,
  [Cakes.NUMBERS_BDAY_CAKE]: DEFAULT_FLAVOUR_OPTIONS,
  [Cakes.NAPOLEON_WITH_BERRIES]: NAPALEON_FLAVOUR_OPTIONS,
  [Cakes.BLACK_CAKE]: DEFAULT_FLAVOUR_OPTIONS,
  [Cakes.BABY_SHOWER_CAKE]: DEFAULT_FLAVOUR_OPTIONS,
  [Cakes.CINNAMOROLL_CAKE]: DEFAULT_FLAVOUR_OPTIONS,
  [Cakes.GRADUATION_CAKE]: DEFAULT_FLAVOUR_OPTIONS,
  [Cakes.GRADUATION_CAKE_2]: DEFAULT_FLAVOUR_OPTIONS,
  [Cakes.WEDDING_CAKE]: DEFAULT_FLAVOUR_OPTIONS,
  [Cakes.BIRTHDAY_QUEEN]: DEFAULT_FLAVOUR_OPTIONS,
  [Cakes.PIKACHU_CAKE]: DEFAULT_FLAVOUR_OPTIONS,
  [Cakes.KUROMI_CAKE]: DEFAULT_FLAVOUR_OPTIONS,
  [Cakes.PEPPA_PIG_CAKE]: DEFAULT_FLAVOUR_OPTIONS,
  [Cakes.WAFFLE_ROSE_CAKE]: DEFAULT_FLAVOUR_OPTIONS,
  ...weddingOptions(DEFAULT_FLAVOUR_OPTIONS),
});

export { Cakes, CakeSizeOptions, CakeFlavourOptions } 